module.exports = __webpack_public_path__ + "static/media/amex.91767060.svg";